import React, { useState, useRef } from 'react';
import OutpatientPage from './OutpatientPage';
import PatientPage from './PatientPage';

const PatientPageWrapper: React.FC = () => {
    const [activeTab, setActiveTab] = useState<'pengesahan' | 'dataPasien'>('dataPasien');
    const outpatientPageRef = useRef<{ handleSubmit: (e: React.FormEvent) => Promise<void> }>(null);

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        if (outpatientPageRef.current) {
            await outpatientPageRef.current.handleSubmit(e);
        }
    };

    return (
        <div className="container">
            <div className="tabs">
                <button
                    className={`tab ${activeTab === 'pengesahan' ? 'active' : ''}`}
                    onClick={() => setActiveTab('pengesahan')}
                >
                    Pengesahan
                </button>
                <button
                    className={`tab ${activeTab === 'dataPasien' ? 'active' : ''}`}
                    onClick={() => setActiveTab('dataPasien')}
                >
                    Data Pasien
                </button>
            </div>

            <div className="tab-content">
                {activeTab === 'pengesahan' && (
                    <OutpatientPage 
                        ref={outpatientPageRef} 
                        onSubmit={handleSubmit}
                        claimDetails={{}}
                    />
                )}
                {activeTab === 'dataPasien' && <PatientPage />}
            </div>

            <style>{`
                .tabs {
                    display: flex;
                    border-bottom: 1px solid #e1e1e1;
                    margin-bottom: 16px;
                }
                .tab {
                    padding: 12px 16px;
                    cursor: pointer;
                    background: transparent;
                    border: none;
                    font-size: 16px;
                    color: #6d7194;
                }
                .tab.active {
                    border-bottom: 2px solid #0094a2;
                    color: #0094a2;
                    font-weight: bold;
                }
                .tab-content {
                    padding: 16px;
                    background: #f9f9f9;
                    border-radius: 8px;
                    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
                }
            `}</style>
        </div>
    );
};

export default PatientPageWrapper;